import { http, createConfig } from 'wagmi';
import { polygon } from 'wagmi/chains';
import { injected, walletConnect } from 'wagmi/connectors';

// Reown (formerly WalletConnect) Project ID
const projectId = process.env.REACT_APP_WALLETCONNECT_PROJECT_ID || '46c3bbdb49474806075d30d5ccbbc704';

console.log('🔑 WalletConnect Project ID:', projectId);
console.log('🌐 Current Origin:', typeof window !== 'undefined' ? window.location.origin : 'SSR');

if (!projectId || projectId === 'YOUR_PROJECT_ID_HERE') {
  console.error('❌ REACT_APP_WALLETCONNECT_PROJECT_ID is not configured properly!');
}

export const config = createConfig({
  chains: [polygon],
  connectors: [
    injected(),  // Generic injected wallet (no specific MetaMask target)
    walletConnect({ 
      projectId,
      metadata: {
        name: 'RouteFlow AI',
        description: 'Send crypto to anyone with @username',
        url: typeof window !== 'undefined' ? window.location.origin : (process.env.REACT_APP_BACKEND_URL || 'https://routeflowai.com'),
        icons: [typeof window !== 'undefined' ? `${window.location.origin}/logo.png` : `${process.env.REACT_APP_BACKEND_URL || 'https://routeflowai.com'}/logo.png`]
      },
      showQrModal: true,
      qrModalOptions: {
        themeMode: 'light',
      }
    }),
  ],
  transports: {
    [polygon.id]: http(process.env.REACT_APP_POLYGON_RPC_URL || 'https://polygon-rpc.com'),
  },
});

export { polygon as chains };

// Supported tokens on Polygon
export const TOKENS = {
  USDT: {
    address: '0xc2132D05D31c914a87C6611C10748AEb04B58e8F',
    decimals: 6,
    symbol: 'USDT',
    name: 'Tether USD'
  },
  USDC: {
    address: '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174',
    decimals: 6,
    symbol: 'USDC',
    name: 'USD Coin'
  }
};

// ERC20 ABI (minimal for transfers)
export const ERC20_ABI = [
  {
    "constant": true,
    "inputs": [{"name": "_owner", "type": "address"}],
    "name": "balanceOf",
    "outputs": [{"name": "balance", "type": "uint256"}],
    "type": "function"
  },
  {
    "constant": false,
    "inputs": [
      {"name": "_to", "type": "address"},
      {"name": "_value", "type": "uint256"}
    ],
    "name": "transfer",
    "outputs": [{"name": "", "type": "bool"}],
    "type": "function"
  },
  {
    "constant": true,
    "inputs": [],
    "name": "decimals",
    "outputs": [{"name": "", "type": "uint8"}],
    "type": "function"
  }
];
